import { Injectable } from '@angular/core';
import { Constant } from '../common/constant';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginModel, LoginCredentialModel } from '../models/login.model';

@Injectable()
export class LoginService {

    public token;

    constructor(private readonly http: HttpClient) {
    }

    login(user: LoginCredentialModel): Observable<LoginModel> {
        const url = Constant.REST_URL + Constant.AUTHENTICATE;
        return this.http.post<LoginModel>(url , user);
    }

    logout(): Observable<any> {
        const url = Constant.REST_URL + Constant.LOGOUT;
        return this.http.post(url, {});
    }
}
